import MarqueeLib from 'react-fast-marquee';
import { useGetNotificationsQuery } from '@/store/api/contentApi';

// Decorative casino icons placed between text segments (cycled by index).
const TICKER_ICONS = ['🇺🇸', '🔥', '♠️', '🎰', '💎', '🃏'];

const Marquee = ({ type }: { type?: string }) => {
  const { data } = useGetNotificationsQuery({ type: 'Alert' });

  // only use real alerts from the API
  const alerts =
    data?.data?.Alert?.filter((item) => item.isActive).map((item) => item.body) || [];
  if (!alerts.length) return null;

  const content = (
    <MarqueeLib speed={60} gradient={false} pauseOnHover direction="left">
      {alerts.map((text, index) => (
        <span key={index} className="flex items-center">
          <span className="leading-none">{text}</span>
          <span className="mx-2 leading-none">{TICKER_ICONS[index % TICKER_ICONS.length]}</span>
        </span>
      ))}
    </MarqueeLib>
  );

  if (type === 'mobile') {
    return (
      <div
        className="whitespace-nowrap overflow-hidden py-[4px] flex-1 text-white bg-transparent"
        style={{ fontFamily: "'Roboto Condensed', sans-serif", fontSize: '12px', fontWeight: 400 }}
      >
        {content}
      </div>
    );
  }

  return (
    <div
      style={{ lineHeight: 'normal' }}
      className="max-xl:hidden text-[12px] font-normal absolute bottom-0 right-0 overflow-hidden whitespace-nowrap w-1/2 text-white"
    >
      {content}
    </div>
  );
};

export default Marquee;
